import styled from "styled-components";

export const Wrapper = styled.div`
.bdr{border:1px solid red !important;}
.ant-select-selection-item-content{
}
.ant-select-multiple.ant-select-lg .ant-select-selection-overflow .ant-select-selection-item-content{
        font-size:14px
}
`;